/** Tiny inline sparkline for table rows. recharts-based, no axes/tooltip. */
import { LineChart, Line } from 'recharts'

export type SparkPoint = { x: string; y: number }

type Props = { data: SparkPoint[]; width?: number; height?: number; color?: string }

export function Sparkline({ data, width = 96, height = 28, color = '#16a34a' }: Props) {
  if (data.length === 0) {
    return (
      <div
        data-testid="sparkline-empty"
        style={{ width, height }}
        className="flex items-center"
        aria-hidden="true"
      >
        <div className="h-px w-full bg-neutral-200 dark:bg-neutral-700" />
      </div>
    )
  }
  const trendUp = data[data.length - 1].y >= data[0].y
  return (
    <div data-testid="sparkline-chart" style={{ width, height }} aria-hidden="true">
      <LineChart width={width} height={height} data={data}>
        <Line
          type="monotone"
          dataKey="y"
          stroke={trendUp ? color : '#dc2626'}
          strokeWidth={1.5}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </div>
  )
}
